import {Component} from '@angular/core';
import {Capacitor} from '@capacitor/core';
import {Keyboard} from '@capacitor/keyboard';
import {StatusBar} from '@capacitor/status-bar';
import {Platform} from '@ionic/angular';
import {LanguageManagerService} from './Services/Shared/language-manager.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent {

  constructor(
    protected platform: Platform,
    protected languageManager: LanguageManagerService
  ) {
    this.initializeApp();
  }


  /**
   * Inicializar aplicación
   *
   */
  initializeApp() {
    this.languageManager.translateApp();

    this.platform.ready().then(() => {

      if (Capacitor.isNativePlatform()) {
        this.initKeyboardEvents();
        this.configureStatusBar();
      }

    });
  }


  /**
   * Inicializar los eventos del teclado
   *
   */
  initKeyboardEvents() {
    Keyboard.addListener('keyboardWillShow', () => {
      document.body.classList.add('keyboard-open');
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setTimeout(() => document.body.classList.remove('keyboard-open'), 250);
    });
  }


  /**
   * Configurar barra de estado
   *
   */
  configureStatusBar() {

    if (Capacitor.getPlatform() === 'android') {
      StatusBar.setOverlaysWebView({overlay: false});
    }

  }

}
